import { render, staticRenderFns } from "./TextTopBarIcon.vue?vue&type=template&id=63c93f35&"
import script from "./TextTopBarIcon.vue?vue&type=script&lang=js&"
export * from "./TextTopBarIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports